import React, { useEffect } from "react";
import { Card, Col, Container, Nav, NavItem, NavLink, Row } from "reactstrap";
import searchIcon from "../../../assets/images/search-normal.png";
import DropDown from "../../../assets/images/dropDownIcon.png";
import { Link } from "react-router-dom";
import Execel from "../../../assets/images/donwloadSheet.png";
import { Constant } from "utils/enums";

const Statement = (props: any) => {
const sellerData: any = localStorage.getItem(Constant.seller);

  const parsedData = JSON.parse(sellerData);
  const sellerId = parsedData?.sellerId;
  console.log("Seller ID:", sellerId);

 
  useEffect(() => {
    console.log(props.allIncomeStatementList);
  });
  const openInvoice = (id: any) => {
    const url = `https://apibuypass.neksoft.com/external/sellerTax/${id}`;
    window.open(url, "_blank");
  };

   const openInvoiceSellerId = (id: any) => {
    const url = `https://apibuypass.neksoft.com/external/sellerTax/${sellerId}`;
    window.open(url, "_blank");
  };

  

  return (
    <div>
      <div className="Statement-one">
        <div className="navigatiovCardDv">
          <Card className=" w-100">
            <h6>View Statement</h6>
            <Row>
              <Col xl="5" lg="5">
                <div className="Data-Range">
                  <div className="mainFields selecDv">
                    <div className="firstChilde">
                      <div className="headindg">Release Status </div>
                      <select onChange={props.onStatusChange}>
                        <option value="">All</option>
                        <option value="released">Released</option>
                        <option value="toBeReleased">Released To Be</option>
                      </select>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg="5">
                <div className="Data-Range">
                  <div className="mainFields firstChi">
                    <div className="firstChilde">
                      <div className="headindg">Statement Nmuber</div>
                      <input
                        type="text"
                        value={props.search}
                        onChange={(e) => props.onSearch(e.target.value)}
                      />
                    </div>
                    <img src={searchIcon} alt="" className="icon" />
                  </div>
                </div>
              </Col>

              <Col className="2">
                <div className="group" onClick={()=>openInvoiceSellerId(sellerId)}>
                  <button data-testing-id="Createvoucher_Promotion">
                    Monthly Statement{" "}
                    <span>
                      <img src={Execel} alt="" />
                    </span>
                  </button>
                </div>
              </Col>
            </Row>

            <div className="AndSelect"></div>
            <div className="GirdWidth ">
              <div className="girdOne">
                <input type="checkbox" />
                <p>Statement Number</p>
              </div>
              <div className="girdTwo">
                <p>Statement Period</p>
              </div>
              <div className="girdThree">
                <p>Released Amount</p>
              </div>
              <div className="girdFour">
                <p>Release Status</p>
              </div>
              <div className="girdFive">
                <p>Action</p>
              </div>
              {/* <div className="girdSix">
                  <p>Statement Number</p>
                </div>
                <div className="girdSeven">
                  <p>Action</p>
                </div> */}
            </div>
          </Card>
        </div>
        <Col xl={12} lg={12}>
          <div className="stateNumber">
            {props?.allIncomeStatementList?.length > 0 ? (
              props.allIncomeStatementList.map((item: any, index: number) => (
                <Card className="w-100">
                  <div className="GirdWidth">
                    <div className="girdOne">
                      <input type="checkbox" />
                      <p className="serial">{item.statementNumber || "-"}</p>
                    </div>
                    <div className="girdTwo">
                      <p>
                        {item?.endPeriod
                          ? new Date(item.endPeriod).toLocaleDateString()
                          : "-"}
                      </p>
                    </div>
                    <div className="girdThree">
                      <p>
                        Rs. <span>{item.amount || "-"}</span>
                      </p>
                    </div>
                    <div className="girdFour">
                      <div className="newOrder">
                        <div className="dot"></div>
                        <p style={{ textTransform: "capitalize" }}>
                          {" "}
                          {item.status === "toBeReleased"
                            ? "To Be Released"
                            : item.status || "-"}
                        </p>
                      </div>{" "}
                    </div>
                    <div className="girdFive">
                      <div className="inVoice">
                        <Link to={`/stateMentOverview/${item._id}`}>
                          <p>View Statement Details</p>
                        </Link>
                        <p onClick={() => openInvoice(item._id)} style={{ cursor: "pointer" }}>Print Invoice </p>
                        <div className="downLoad">
                          <p>Download</p>
                          <img src={DropDown} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              ))
            ) : (
              <div className="noDataFound">
                <p className="text-center fs-3">No Data Found !</p>
              </div>
            )}
          </div>
        </Col>
      </div>
    </div>
  );
};

export default Statement;
